import { useApiMutation, useApiMutationPaging, useApiMutationCommentReplyPaging, useApiMutationFormData } from './common/ApiCommon';


export const ApiMyGiftBoxList = (options) => {
    const subUrl = "/my/gift_box_list";
    const data = options?.data || {};
    const successFn = options?.onSuccess || (()=>{});
    const errorFn = options?.onError || (()=>{});
    const bottomFn = options?.bottomFn || (()=>{});
    const bottomRef = options?.bottomRef || (()=>{});
    const perPage = options?.perPage || 30;
    const pageName = options?.pageName || "page";
    const perPageName = options?.perPageName || "per_page";

    return useApiMutationPaging(subUrl, data, successFn, errorFn, bottomFn, perPage, pageName, perPageName, bottomRef);
};

export const ApiMyGiftBoxGet = (options) => {

    const subUrl = "/my/gift_box_get ";
    const successFn = options?.onSuccess || (()=>{});
    const errorFn = options?.onError || (()=>{});

    const mutation = useApiMutation(subUrl, successFn, errorFn);
    return mutation;
};


export const ApiMyBookmarkSet = (options) => {

    const subUrl = "/my/bookmark_set ";
    const successFn = options?.onSuccess || (()=>{});
    const errorFn = options?.onError || (()=>{});

    const mutation = useApiMutation(subUrl, successFn, errorFn);
    return mutation;
};


export const ApiMyBookmarkBell = (options) => {

    const subUrl = "/my/bookmark_bell ";
    const successFn = options?.onSuccess || (()=>{});
    const errorFn = options?.onError || (()=>{});

    const mutation = useApiMutation(subUrl, successFn, errorFn);
    return mutation;
};